module.exports = __webpack_public_path__ + "img/UnderMaintenance.21719a2f.png";